'use client';

import { forwardRef, memo } from 'react';
import { motion } from 'motion/react';
import { CldImage } from 'next-cloudinary';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import type { ImageProps } from './types';

const Image = forwardRef<HTMLImageElement, ImageProps>(
  (
    {
      src,
      alt = 'Image',
      width,
      height,
      fill = false,
      sizes = '100vw',
      responsive = {},
      className = '',
      ...props
    },
    ref,
  ) => {
    const MotionCldImage = motion.create(CldImage);

    if (!src) {
      return null;
    }

    return (
      <ResponsiveWrapper responsive={responsive}>
        <MotionCldImage
          ref={ref}
          src={src}
          alt={alt}
          width={width}
          height={height}
          fill={fill}
          sizes={sizes}
          quality={80}
          className={className}
          {...props}
        />
      </ResponsiveWrapper>
    );
  },
);

Image.displayName = 'Image';

export default memo(Image);
